import { cloneDeep } from "lodash";
import React, { Component, Fragment } from "react";
import NotificationSystem from "react-notification-system";
import { NOTIFICATION_SYSTEM_STYLE } from "../utils/constants";
import { AiFillCloseCircle } from "react-icons/ai";
import {
  Card,
  Row,
  Col,
  Label,
  Button,
  Input,
  CardBody,
  Form,
  Modal,
  FormGroup,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import Select from "react-select";
import * as Server from "../Server";
import Page from "../components/Page";
import DatePicker from "react-datepicker";
import PageSpinner from "../components/PageSpinner";
import SelectTeamPlayers from "./SelectTeamPlayers";
import * as GeneralFunctions from "../GeneralFunctions";

class TeamEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      staff: [],
      players: [],
      playerOptions: [],
      staffOptions: [],
      team: props.team || {},
      showLoader: false,
      staffValues: [],
      selectedStaff: [],
      selectedplayers: [],
      selectplayersPage: false,
      gotSportTeamName: "",
      homeOrAway: "",
      uniform: "",
      arrivalTime: "",
      discountAmounts: [],
    };
  }

  componentDidMount() {
    this.props.teamEditKey === "Create-Team" && this.setState({ team: {} });
    this.getPlayers();
    this.getStaff();
    this.getRegistrationForm();
    if (this.props.teamEditKey === "Create-Team") {
      this.setState((prevState) => ({
        team: {
          ...prevState.team,
          gender: "boys",
          isVisible: true,
        },
      }));
    } else {
      let discountAmounts = this.props.team.camps.length
        ? this.props.team.camps.map((camp) => {
            let discountAmount = this.props.team.discountAmounts.find(
              (discountAmount) => discountAmount.campId === camp._id
            );
            return {
              _id: discountAmount ? discountAmount._id : null,
              campId: camp._id,
              name: camp.name,
              price: discountAmount ? discountAmount.price : 0,
            };
          })
        : [];
      this.setState({
        gotSportTeamName: this.props.team.teamSettings.gotSportTeamName || "",
        homeOrAway: this.props.team.teamSettings.homeOrAway || "",
        uniform: this.props.team.teamSettings.uniform || "",
        arrivalTime: this.props.team.teamSettings.arrivalTime || "",
        discountAmounts,
      });
    }
  }

  getPlayers = async () => {
    try {
      this.setState({
        showLoader: true,
      });
      let response = await Server.request({
        url: "rushsoccer/playerlist",
        method: "GET",
      });
      if (response) {
        this.setState({
          showLoader: false,
          players: response.players,
        });
        let selectedPlayer = [];
        if (this.props.teamEditKey !== "Create-Team") {
          const prefillPlayer = response.players.filter((user) =>
            this.state.team.players.find(
              (playerId) => playerId === user.child._id
            )
          );
          await prefillPlayer.map((player) => selectedPlayer.push(player));
        }
        await this.setState({ selectedplayers: selectedPlayer });

        this.setState((prevState) => ({
          team: {
            ...prevState.team,
            players: [],
          },
        }));
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  getStaff = async () => {
    try {
      this.setState({
        showLoader: true,
      });
      let response = await Server.request({
        url: "rushsoccer/team/stafflist",
        method: "GET",
      });
      if (response) {
        this.setState({
          showLoader: false,
          staff: response.staff,
        });
        this.state.staffOptions.length > 0 &&
          this.setState({ staffOptions: [] });
        this.state.staff.map((staff) =>
          this.state.staffOptions.push({
            label: staff.data.firstName + " " + staff.data.lastName,
            value: staff._id,
          })
        );
        let selectedStaff = [];
        if (this.props.teamEditKey !== "Create-Team") {
          const prefillStaff = response.staff.filter((staff) =>
            this.state.team.staffMemberId.find(
              (staffMember) => staffMember === staff._id
            )
          );
          prefillStaff.map(
            (staff) => (
              this.state.staffValues.push(staff._id),
              selectedStaff.push({
                label: staff.data.firstName + " " + staff.data.lastName,
                value: staff._id,
              })
            )
          );
        }
        this.setState({ selectedStaff: selectedStaff });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  createStaff = async (event) => {
    if (event) event.preventDefault();
    let user = GeneralFunctions.getAuthUser();
    try {
      this.setState({ showLoader: true });
      let response = await Server.serverRequest({
        url: "rushUser/registerStaff",
        method: "POST",
        data: {
          data: this.state.staff,
          clubId: user.connectUserId,
        },
      });
      if (response) {
        this.setState({ showLoader: false, staff: {} });
        this.notificationSystem.addNotification({
          message: response.message,
          level: "success",
        });
        this.getStaff();
        this.toggleAddStaffModel();
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  getRegistrationForm = async () => {
    let user = GeneralFunctions.getAuthUser();
    try {
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: `rushsoccer/registration/form?clubId=${user.connectUserId}`,
        method: "GET",
      });
      if (
        response.registrationFormDetails &&
        response.registrationFormDetails.registerForm
      ) {
        let allFields = response.registrationFormDetails.registerForm.reduce(
          (previousValue, currentValue) => {
            previousValue.push(...currentValue.fields);
            return previousValue;
          },
          []
        );
        let Fields = allFields.filter(
          (form) =>
            form.for.value === "staff" &&
            form.default === true &&
            form.inputType !== "fileupload"
        );
        this.setState({
          showLoader: false,
          registerFormFieldsStaff: Fields,
        });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  getPlayersForEdit = async () => {
    try {
      this.setState({
        showLoader: true,
      });
      let response = await Server.request({
        url: "rushsoccer/teamedit/players",
        method: "POST",
        data: {
          teamId: this.state.team._id,
          campId: this.state.team.camp.campId,
        },
      });
      if (response) {
        await this.setState({
          showLoader: false,
        });
        this.state.playerOptions.length > 0 &&
          this.setState({ playerOptions: [] });
        response.teamPlayers.map((player) =>
          this.state.playerOptions.push({
            key: player.child.data.firstName + " " + player.child.data.lastName,
            id: player.child._id,
          })
        );
        this.setState({ selectedplayers: this.state.playerOptions });
        response.unAllocatedPlayers.map((player) =>
          this.state.playerOptions.push({
            key: player.child.data.firstName + " " + player.child.data.lastName,
            id: player.child._id,
          })
        );
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  createTeam = async (event) => {
    event.preventDefault();
    const ids = [];
    await this.state.selectedplayers.map((player) =>
      ids.push(player.child._id)
    );
    await this.setState((prevState) => ({
      team: {
        ...prevState.team,
        players: ids,
        activity: "soccer",
        staffMemberId: this.state.staffValues,
        teamSettings: {
          gotSportTeamName: this.state.gotSportTeamName,
          homeOrAway: this.state.homeOrAway,
          uniform: this.state.uniform,
          arrivalTime: this.state.arrivalTime,
        },
        discountAmounts: [],
      },
      showLoader: true,
    }));
    try {
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "rushsoccer/createteam",
        method: "POST",
        data: this.state.team,
      });
      if (response) {
        this.setState({
          showLoader: false,
        });
        this.closeEdit();
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  updateTeam = (event) => {
    event.preventDefault();
    const ids = [];
    this.state.selectedplayers.map((player) => ids.push(player.child._id));
    this.setState(
      (prevState) => ({
        team: {
          ...prevState.team,
          players: ids,
          activity: "soccer",
          staffMemberId: this.state.staffValues,
          teamSettings: {
            gotSportTeamName: this.state.gotSportTeamName,
            homeOrAway: this.state.homeOrAway,
            uniform: this.state.uniform,
            arrivalTime: this.state.arrivalTime,
          },
          discountAmounts: this.state.discountAmounts,
        },
        showLoader: true,
      }),
      async () => {
        try {
          let response = await Server.request({
            url: "rushsoccer/team/update",
            method: "POST",
            data: this.state.team,
          });
          if (response) {
            this.closeEdit();
            this.setState({ showLoader: false, team: {} });
          }
        } catch (error) {
          this.setState({ showLoader: false });
          this.notificationSystem.addNotification({
            message: error.message,
            level: "error",
          });
        }
      }
    );
  };

  onRemove = (user) => {
    if (this.state.selectedplayers.length) {
      this.setState({
        selectedplayers: this.state.selectedplayers.filter(
          (player) => player.child._id !== user.child._id
        ),
      });
    }
  };

  closeEdit() {
    this.props.closeTeamEditPage();
  }

  getSelectedPlayers = async (players) => {
    await this.setState((prevState) => ({
      selectedplayers: prevState.selectedplayers.concat(players),
    }));
    let rushUsers = [];
    await this.state.selectedplayers.filter(function (player) {
      let i = rushUsers.findIndex((x) => x.child._id === player.child._id);
      if (i <= -1) {
        rushUsers.push(player);
      }
      return null;
    });
    await this.setState({ selectedplayers: rushUsers });
  };

  toggleSelectTeamPlayers() {
    this.setState({ selectplayersPage: !this.state.selectplayersPage });
  }

  handleTeamStaffChange = (staff) => {
    let staffIds = staff.map((staff) => staff.value);
    this.setState({
      selectedStaff: staff,
      staffValues: staffIds,
    });
  };

  toggleAddStaffModel = (event) => {
    if (event) event.preventDefault();
    this.setState({
      addStaffModel: !this.state.addStaffModel,
      staff: {},
    });
  };

  render() {
    return (
      <Fragment>
        {this.state.selectplayersPage ? (
          <SelectTeamPlayers
            teamName={this.state.team.name}
            players={
              this.state.players.filter(
                (item) => !this.state.selectedplayers.includes(item)
              ) || {}
            }
            playersAdded={this.state.selectedplayers.map(
              (selectedplayer) => selectedplayer.child._id
            )}
            getPlayers={this.getSelectedPlayers}
            closeSelectplayersPage={(e) => this.toggleSelectTeamPlayers()}
          ></SelectTeamPlayers>
        ) : (
          <div>
            <Page
              title={this.props.teamEditKey}
              breadcrumbs={[{ name: this.props.teamEditKey, active: true }]}
            >
              <PageSpinner showLoader={this.state.showLoader} />
              <Card>
                <CardBody>
                  <Form
                    onSubmit={
                      this.props.teamEditKey === "Create-Team"
                        ? this.createTeam
                        : this.updateTeam
                    }
                  >
                    <Row>
                      <Col sm={12} md={12} lg={6} xl={6}>
                        <div
                          onChange={(event) => {
                            event.persist();
                            let value =
                              event.target.value === "true" ? true : false;
                            this.setState((prevState) => ({
                              team: {
                                ...prevState.team,
                                isVisible: value,
                              },
                            }));
                          }}
                          className="d-flex"
                        >
                          <Label style={{ marginRight: "20px" }}>Status:</Label>
                          <FormGroup check className="pr-4">
                            <Input
                              id="enable"
                              type="radio"
                              name="enable"
                              value="true"
                              checked={this.state.team.isVisible === true}
                            />
                            <Label check for="enable">
                              Enable
                            </Label>
                          </FormGroup>
                          <FormGroup check>
                            <Input
                              type="radio"
                              name="disable"
                              id="disable"
                              value="false"
                              checked={this.state.team.isVisible === false}
                            />
                            <Label check for="disable">
                              Disable
                            </Label>
                          </FormGroup>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={12} md={12} lg={6} xl={6}>
                        <div
                          onChange={(event) => {
                            event.persist();
                            this.setState((prevState) => ({
                              team: {
                                ...prevState.team,
                                gender: event.target.value,
                              },
                            }));
                          }}
                          className="d-flex"
                        >
                          <Label className="mr-3">Gender:</Label>
                          <FormGroup check className="pr-4">
                            <Input
                              id="boys"
                              type="radio"
                              name="boys"
                              value="boys"
                              checked={
                                this.state.team.gender &&
                                this.state.team.gender === "boys"
                              }
                            />
                            <Label
                              check
                              for="boys"
                              style={{ marginRight: "13px" }}
                            >
                              Boys
                            </Label>
                          </FormGroup>
                          <FormGroup check>
                            <Input
                              type="radio"
                              name="girls"
                              id="girls"
                              value="girls"
                              checked={
                                this.state.team.gender &&
                                this.state.team.gender === "girls"
                              }
                            />
                            <Label check for="girls">
                              Girls
                            </Label>
                          </FormGroup>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={12} md={12} lg={6} xl={6}>
                        <FormGroup>
                          <Label>Team Name :</Label>
                          <Input
                            type="text"
                            value={this.state.team.name || ""}
                            onChange={(event) => {
                              event.persist();
                              this.setState((prevState) => ({
                                team: {
                                  ...prevState.team,
                                  name: event.target.value,
                                },
                              }));
                            }}
                            placeholder="Team Name"
                            required
                          ></Input>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={12} md={12} lg={6} xl={6}>
                        <FormGroup>
                          <Label>Select an Activity :</Label>
                          <Input
                            type="select"
                            value={this.state.team.activity || "soccer"}
                            onChange={(event) => {
                              event.persist();
                              this.setState((prevState) => ({
                                team: {
                                  ...prevState.team,
                                  activity: event.target.value,
                                },
                              }));
                            }}
                            placeholder="Activity"
                            required
                          >
                            <option value="" disabled>
                              Select
                            </option>
                            <option value="soccer">Soccer </option>
                          </Input>
                        </FormGroup>
                      </Col>
                      {this.state.staffOptions &&
                        this.state.staffOptions.length === 0 && (
                          <Col style={{ paddingTop: 32 }}>
                            <Button
                              onClick={(event) =>
                                this.toggleAddStaffModel(event)
                              }
                            >
                              Add Staff
                            </Button>
                          </Col>
                        )}
                    </Row>
                    <Row>
                      <Col sm={12} md={12} lg={6} xl={6}>
                        <FormGroup>
                          <Label>Select Staff :</Label>
                          <Select
                            isMulti
                            options={this.state.staffOptions || []}
                            closeMenuOnSelect={false}
                            value={this.state.selectedStaff}
                            onChange={this.handleTeamStaffChange}
                            className="basic-multi-select"
                            classNamePrefix="select"
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={12} md={12} lg={6} xl={6}>
                        <FormGroup>
                          <Label>Birth Year Start Date :</Label>
                          <DatePicker
                            selected={
                              this.state.team.startDate
                                ? new Date(this.state.team.startDate)
                                : ""
                            }
                            onChange={(date) => {
                              date.setDate(1);
                              date.setSeconds(1);
                              let utcDate = new Date(
                                date.getTime() -
                                  date.getTimezoneOffset() * 60000
                              ).toISOString();
                              this.setState((prevState) => ({
                                team: {
                                  ...prevState.team,
                                  startDate: utcDate,
                                },
                              }));
                            }}
                            dateFormat="MM/yyyy"
                            showMonthYearPicker
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={12} md={12} lg={6} xl={6}>
                        <FormGroup>
                          <Label>Birth Year End Date :</Label>
                          <DatePicker
                            selected={
                              this.state.team.endDate
                                ? new Date(this.state.team.endDate)
                                : ""
                            }
                            onChange={(date) => {
                              let LastDay = new Date(
                                date.getFullYear(),
                                1 + date.getMonth(),
                                0
                              ).getDate();
                              date.setDate(LastDay);
                              date.setSeconds(1);
                              let utcDate = new Date(
                                date.getTime() -
                                  date.getTimezoneOffset() * 60000
                              ).toISOString();
                              this.setState((prevState) => ({
                                team: {
                                  ...prevState.team,
                                  endDate: utcDate,
                                },
                              }));
                            }}
                            dateFormat="MM/yyyy"
                            showMonthYearPicker
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Button
                          onClick={(event) =>
                            this.toggleSelectTeamPlayers(event)
                          }
                        >
                          Add Players
                        </Button>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={12} md={12} lg={6} xl={6}>
                        <FormGroup>
                          <Label>Selected Players :</Label>
                          <div
                            className="d-flex flex-wrap py-2"
                            style={{
                              border: "1px solid #ced4da",
                              borderRadius: "0.25rem",
                              width: "100%",
                            }}
                          >
                            {this.state.selectedplayers &&
                            this.state.selectedplayers.length ? (
                              this.state.selectedplayers.map((player) => (
                                <div
                                  className="p-1 m-1 d-flex"
                                  style={{
                                    border: "1px solid #ced4da",
                                    borderRadius: "0.25rem",
                                  }}
                                >
                                  <Label style={{ margin: "auto" }}>
                                    {player.child.data.firstName +
                                      " " +
                                      player.child.data.lastName}
                                  </Label>
                                  <AiFillCloseCircle
                                    style={{
                                      margin: "auto 5px",
                                      color: "#19527c",
                                    }}
                                    size={20}
                                    onClick={() => this.onRemove(player)}
                                  />
                                </div>
                              ))
                            ) : (
                              <Label className="text-muted my-auto pl-2">
                                No Players Selected
                              </Label>
                            )}
                          </div>
                        </FormGroup>
                      </Col>
                    </Row>
                    {this.state.discountAmounts.length ? (
                      <>
                        <Row>
                          <Col sm={12} md={12} lg={6} xl={6}>
                            <Label>Discount Amounts :</Label>
                          </Col>
                        </Row>
                        <Row>
                          <Col sm={6} md={6} lg={3} xl={3}>
                            <Label>Event Name :</Label>
                          </Col>
                          <Col sm={6} md={6} lg={3} xl={3}>
                            <Label>Amount :</Label>
                          </Col>
                        </Row>
                        {this.state.discountAmounts.map(
                          (discountAmount, index) => (
                            <Row key={index}>
                              <Col sm={6} md={6} lg={3} xl={3}>
                                <FormGroup>
                                  <Input
                                    disabled
                                    type="text"
                                    value={discountAmount.name || ""}
                                  ></Input>
                                </FormGroup>
                              </Col>
                              <Col sm={6} md={6} lg={3} xl={3}>
                                <FormGroup>
                                  <Input
                                    type="number"
                                    min="0"
                                    value={discountAmount.price || ""}
                                    onChange={(event) => {
                                      let discountAmounts = cloneDeep(
                                        this.state.discountAmounts
                                      );
                                      discountAmounts[index].price =
                                        event.target.value >= 0
                                          ? event.target.value
                                          : "";
                                      this.setState({ discountAmounts });
                                    }}
                                    placeholder="Enter the amount"
                                  ></Input>
                                </FormGroup>
                              </Col>
                            </Row>
                          )
                        )}
                      </>
                    ) : null}
                    <Row>
                      <Col sm={12} md={12} lg={6} xl={6}>
                        <Label>Team Settings :</Label>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={12} md={12} lg={6} xl={6}>
                        <FormGroup>
                          <Label>Got Sport Team Name :</Label>
                          <Input
                            type="text"
                            value={this.state.gotSportTeamName || ""}
                            onChange={(event) =>
                              this.setState({
                                gotSportTeamName: event.target.value,
                              })
                            }
                            placeholder="Team Name"
                          ></Input>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={12} md={12} lg={6} xl={6}>
                        <FormGroup>
                          <Label>Home or Away:</Label>
                          <Input
                            type="select"
                            value={this.state.homeOrAway || ""}
                            onChange={(event) =>
                              this.setState({ homeOrAway: event.target.value })
                            }
                            placeholder="Activity"
                          >
                            <option value="" disabled>
                              Select
                            </option>
                            <option value="home">Home </option>
                            <option value="away">Away </option>
                          </Input>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={12} md={12} lg={6} xl={6}>
                        <FormGroup>
                          <Label for="Uniform">Uniform:</Label>
                          <Input
                            type="text"
                            name="Uniform"
                            placeholder="Uniform"
                            value={this.state.uniform || ""}
                            onChange={(event) =>
                              this.setState({ uniform: event.target.value })
                            }
                          ></Input>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={12} md={12} lg={6} xl={6}>
                        <FormGroup>
                          <Label for="Arrival time">Arrival time:</Label>
                          <div className="d-flex">
                            <Input
                              type="number"
                              className="mr-2"
                              style={{ width: "40%" }}
                              name="Arrival time"
                              placeholder="Arrival time"
                              min="0"
                              max="59"
                              value={this.state.arrivalTime || ""}
                              onChange={(event) =>
                                event.target.value >= 0 &&
                                event.target.value <= 59
                                  ? this.setState({
                                      arrivalTime: event.target.value,
                                    })
                                  : ""
                              }
                            ></Input>
                            <p
                              className="text-muted"
                              style={{ margin: "auto 0px" }}
                            >
                              minutes before the starting time
                            </p>
                          </div>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={12} md={12} lg={6} xl={6}>
                        <FormGroup>
                          <Button type="submit">
                            {this.props.teamEditKey === "Create-Team"
                              ? "Create Team"
                              : "Update Team"}
                          </Button>
                          <Button
                            className="ml-5"
                            onClick={(e) => {
                              this.closeEdit();
                            }}
                          >
                            Cancel
                          </Button>
                        </FormGroup>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
              {this.state.addStaffModel ? (
                <Modal
                  isOpen={this.state.addStaffModel}
                  toggle={(event) => this.toggleAddStaffModel(event)}
                  className="modal-md"
                >
                  <Form
                    className="form"
                    onSubmit={(event) => this.createStaff(event)}
                  >
                    <ModalHeader
                      toggle={(event) => this.toggleAddStaffModel(event)}
                    >
                      <Label className="h3 ml-3">
                        <b>Add Staff</b>
                      </Label>
                    </ModalHeader>
                    <ModalBody>
                      <Card>
                        <CardBody>
                          {this.state.registerFormFieldsStaff.length > 0 &&
                            this.state.registerFormFieldsStaff.map(
                              (field, index) => (
                                <Row key={index}>
                                  <Col xs={12}>
                                    <FormGroup>
                                      <Label for={field.name}>
                                        {field.placeholder}
                                      </Label>
                                      <Input
                                        type={field.inputType}
                                        required={field.required}
                                        name={field.name}
                                        placeholder={field.placeholder}
                                        value={
                                          this.state.staff[field.keyName] || ""
                                        }
                                        onChange={(event) => {
                                          event.persist();
                                          this.setState((prevState) => ({
                                            staff: {
                                              ...prevState.staff,
                                              [field.keyName]:
                                                event.target.value,
                                            },
                                          }));
                                        }}
                                      ></Input>
                                    </FormGroup>
                                  </Col>
                                </Row>
                              )
                            )}
                        </CardBody>
                      </Card>
                    </ModalBody>
                    <ModalFooter>
                      <div className="d-flex align-items-center justify-content-center ">
                        <Button className="mr-3" type="submit">
                          Add Staff
                        </Button>
                        <Button
                          onClick={(event) => this.toggleAddStaffModel(event)}
                        >
                          Cancel
                        </Button>
                      </div>
                    </ModalFooter>
                  </Form>
                </Modal>
              ) : null}
              <NotificationSystem
                dismissible={false}
                ref={(notificationSystem) =>
                  (this.notificationSystem = notificationSystem)
                }
                style={NOTIFICATION_SYSTEM_STYLE}
              />
            </Page>
          </div>
        )}
      </Fragment>
    );
  }
}

export default TeamEdit;
